module.exports = __webpack_public_path__ + "assets/img/em_toggle_p.80b05b3.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/em_toggle_p.png
// module id = nsL/
// module chunks = 0